import Vue from 'vue';
import Vuex from 'vuex';
import Personas from './Personas';
import Empresas from "./Empresas";
import UrgPlus from './UrgPlus';
import Misc from "./Misc";
import Conecta from "./Conecta";

Vue.use(Vuex)

export default new Vuex.Store({
  modules:
  {
    Personas:Personas,
    Empresas:Empresas,
    UrgPlus: UrgPlus,
    Misc:Misc,
    Conecta: Conecta
  }
});

